import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getWebCamsPage } from "@/_pages/web-cams/api";
import type {
  WebCamsPageType,
  WebCamsType,
  WebCamTypesType,
} from "@/_pages/web-cams/model";
import { WebCamsPage } from "@/_pages/web-cams/ui";

type PageProps = {
  cms: {
    filters: WebCamTypesType[];
    webCams: WebCamsType;
    pageData: WebCamsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { filters, webCams, pageData },
  } = props;

  return (
    <WebCamsPage filters={filters} webCams={webCams} pageData={pageData} />
  );
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getWebCamsPage()),
      };
    },
    { res },
  );
}

export default Page;
